export default "__VITE_ASSET__WSenEQTA__"